import React from "react";
import { DR_GRADE_STYLES, DME_COLORS } from "../../utlis";

const PdfTemplate = ({ heading, reportindex, visitDate, patientDetails, images, nextSteps, disclaimer, leftInference, rightInference, required, singleImageReason, leftDME = null, rightDME = null, operatorOverride = { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } }, treatmentProvided = null, furtherReferralRequired = null }) => {
    
    const styles = {
        heading: {
            fontSize: "18px",
            color: "#000000",
            lineHeight: "20px",
            fontWeight: "500",
        },
        subHeading: {
            fontSize: "18px",
            color: "#000000",
            lineHeight: "21px",
            fontWeight: "500",
            marginTop: "15px",
        },
        textHeading: {
            fontSize: "16px",
            color: "#000000",
            lineHeight: "21px",
            fontWeight: "500",
        },
        text: {
            fontSize: "14px",
            color: "#404040",
            lineHeight: "18px",
            fontWeight: "400",
        },
        text2: {
            fontSize: "15px",
            color: "#404040",
            lineHeight: "18px",
            fontWeight: "500",
            marginTop: "5px",
        },
    };

    return (
        <div id="pdf-template-container" style={{ width: "21.01cm", maxWidth: "21.01cm", height: "29.62cm", maxHeight: "29.62cm", margin: 0, padding: "40px 30px", boxSizing: "border-box" }}>
            <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <img src="/assests/images/MadhuNetrAI Logo.png" style={{width:"180px"}} alt="MadhuNetraAI logo"/>
                <img src="/assests/images/New-Logos.png" style={{width:"140px"}} alt="Indian Government"/>
            </div>
            <div style={{ textAlign: "center", fontSize: "24px", fontWeight: "500", lineHeight: "22.54px", color: "#404040", marginBottom: "15px", marginTop: "0px" }}>
                {heading}
            </div>
            <div style={{display: "flex", justifyContent: "space-between"}}>
                <div>{`Report: ${reportindex}`}</div>
                <div>{visitDate}</div>
            </div>
            
            <div style={{ border: "0.1px solid #ccc", borderRadius: "4px", marginTop: "10px", padding: "10px 18px" }}>
                {/* Patient Basic Info */}
                <div style={{ display: "flex", flexWrap: "wrap", columnGap: "25px", rowGap: "10px", marginBottom: "15px" }}>
                    {patientDetails.filter(p => 
                        p.label !== "Diabetes" && p.label !== "Patient Reported Vision Issues"
                    ).map((patient, idx) => (
                        <div key={idx} style={{ textAlign: "left" }}>
                            <div style={styles.textHeading}>{patient.label}</div>
                            <div style={styles.text}>{patient.value}</div>
                        </div>
                    ))}
                </div>
                
                {/* Best Corrected Visual Acuity (Left) and Diabetes (Right) */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: "10px", borderTop: "1px solid #e0e0e0", paddingTop: "15px" }}>
                    {/* Left Side: Best Corrected Visual Acuity */}
                    <div style={{ flex: "0 0 auto", maxWidth: "50%" }}>
                        {(() => {
                            const visionIssues = patientDetails.find(p => p.label === "Patient Reported Vision Issues");
                            if (visionIssues && visionIssues.value) {
                                // Split only at the Distant/Near boundary — the value itself already
                                // uses ", " to join Left/Right within each section (e.g. "Distant Vision -
                                // 5/60 Left, 6/12 Right, Near Vision - N18 Left, N24 Right"), so a naive
                                // split(', ') would cut "6/12 Right" off as its own orphaned part.
                                const value = visionIssues.value;
                                const nearIdx = value.indexOf(', Near Vision - ');
                                let distant = null;
                                let near = null;
                                if (value.startsWith('Distant Vision')) {
                                    distant = nearIdx !== -1 ? value.slice(0, nearIdx) : value;
                                }
                                if (nearIdx !== -1) {
                                    near = value.slice(nearIdx + 2); // +2 skips the leading ", "
                                } else if (value.startsWith('Near Vision')) {
                                    near = value;
                                }
                                return (
                                    <>
                                        <div style={styles.textHeading}>Best Corrected Visual Acuity</div>
                                        {distant && (
                                            <div style={{...styles.text, marginTop: "4px"}}>{distant}</div>
                                        )}
                                        {near && (
                                            <div style={{...styles.text, marginTop: "4px"}}>{near}</div>
                                        )}
                                    </>
                                );
                            }
                            return null;
                        })()}
                    </div>
                    
                    {/* Right Side: Diabetes */}
                    <div style={{ flex: "0 0 auto", textAlign: "right", marginLeft: "auto" }}>
                        {(() => {
                            const diabetes = patientDetails.find(p => p.label === "Diabetes");
                            if (diabetes) {
                                return (
                                    <>
                                        <div style={styles.textHeading}>Diabetes</div>
                                        <div style={{...styles.text, marginTop: "4px"}}>{diabetes.value}</div>
                                    </>
                                );
                            }
                            return null;
                        })()}
                    </div>
                </div>
            </div>
            <div style={{ margin: "20px 0" }}>
                <div style={{ fontSize: "18px", lineHeight: "24px", fontWeight: "500", color: "#000000" }}>
                    Referral: <span style={{ fontWeight: "500", color: "#404040" }}>{required ?? "—"}</span>
                </div>
            </div>
            {(treatmentProvided || furtherReferralRequired) && (
                <div style={{ margin: "10px 0 20px 0" }}>
                    <div style={styles.subHeading}>Assessment completed</div>
                    {treatmentProvided && (
                        <div style={{...styles.text2, marginTop: "8px"}}>
                            Treatment Provided: <span style={{ fontWeight: "600" }}>{treatmentProvided === 'yes' ? 'Yes' : 'No'}</span>
                        </div>
                    )}
                    {furtherReferralRequired && (
                        <div style={styles.text2}>
                            Further Referral Required: <span style={{ fontWeight: "600" }}>{furtherReferralRequired === 'yes' ? 'Yes' : 'No'}</span>
                        </div>
                    )}
                </div>
            )}
            <div style={{ display: "flex", columnGap: "30px", width: "100%", alignItems: "stretch", boxSizing: "border-box" }}>
                <div style={{ flex: "1 1 0", minWidth: 0, boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
                    <div style={{ ...styles.subHeading, marginTop: "10px", marginBottom: "4px" }}>Right Eye</div>
                    <div style={{ width: "100%", height: "280px", maxHeight: "280px" }}>
                        {images.img2 && (images.img2.startsWith("data:image/") || images.img2.startsWith("data:application/octet-stream")) && !images.img2.includes("data:image/svg+xml") ? (
                            <img style={{ width: "100%", height: "280px", objectFit: "cover" }} src={images.img2} alt="right-eye-img" />
                        ) : (
                            <div style={{
                                width: "100%",
                                height: "280px",
                                boxSizing: "border-box",
                                backgroundColor: "#f5f5f5",
                                border: "2px dashed #ccc", 
                                display: "flex", 
                                flexDirection: "column", 
                                alignItems: "center", 
                                justifyContent: "center",
                                textAlign: "center",
                                padding: "20px",
                                objectFit: "cover"
                            }}>
                                <div style={{
                                    width: "60px",
                                    height: "60px",
                                    border: "2px solid #ccc",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "10px",
                                    backgroundColor: "#fff"
                                }}>
                                    <div style={{
                                        width: "40px",
                                        height: "40px",
                                        border: "2px solid #ccc",
                                        borderRadius: "4px",
                                        position: "relative"
                                    }}>
                                        <div style={{
                                            position: "absolute",
                                            top: "-2px",
                                            left: "-2px",
                                            width: "44px",
                                            height: "2px",
                                            backgroundColor: "#ccc",
                                            transform: "rotate(45deg)",
                                            transformOrigin: "center"
                                        }}></div>
                                    </div>
                                </div>
                                <div style={{ 
                                    fontSize: "16px", 
                                    color: "#999", 
                                    fontWeight: "500"
                                }}>
                                    Image Not Available
                                </div>
                            </div>
                        )}
                    </div>
                    <div style={{ marginTop: "10px" }}>
                        {images.img2 && (images.img2.startsWith("data:image/") || images.img2.startsWith("data:application/octet-stream")) && !images.img2.includes("data:image/svg+xml") ? (
                        <>
                            <div style={styles.subHeading}>AI Inference:</div>
                            {operatorOverride?.right?.fundus ? (
                                <div style={styles.text2}>Abstained due to operator override</div>
                            ) : (
                                <>
                                    <div style={{...styles.text2, color: DR_GRADE_STYLES[rightInference]?.color || styles.text2.color, fontWeight: "600"}}>{rightInference}</div>
                                    {rightDME && (
                                        <div style={{...styles.text2, marginTop: "5px", color: rightDME === "DME" ? DME_COLORS.present : DME_COLORS.absent, fontWeight: "600"}}>
                                            {rightDME === "DME" ? "Diabetic Macular Edema (DME) present" : "Diabetic Macular Edema (DME) absent"}
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <div style={styles.subHeading}>Image Not Available:</div>
                            <div style={styles.text2}>{singleImageReason || "Single image mode"}</div>
                        </>
                        )}
                    </div>
                </div>
                <div style={{ flex: "1 1 0", minWidth: 0, boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
                    <div style={{ ...styles.subHeading, marginTop: "10px", marginBottom: "4px" }}>Left Eye</div>
                    <div style={{ width: "100%", height: "280px", maxHeight: "280px" }}>
                        {images.img1 && (images.img1.startsWith("data:image/") || images.img1.startsWith("data:application/octet-stream")) && !images.img1.includes("data:image/svg+xml") ? (
                            <img style={{ width: "100%", height: "280px", objectFit: "cover" }} src={images.img1} alt="left-eye-img" />
                        ) : (
                            <div style={{
                                width: "100%",
                                height: "280px",
                                boxSizing: "border-box",
                                backgroundColor: "#f5f5f5",
                                border: "2px dashed #ccc", 
                                display: "flex", 
                                flexDirection: "column", 
                                alignItems: "center", 
                                justifyContent: "center",
                                textAlign: "center",
                                padding: "20px",
                                objectFit: "cover"
                            }}>
                                <div style={{
                                    width: "60px",
                                    height: "60px",
                                    border: "2px solid #ccc",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "10px",
                                    backgroundColor: "#fff"
                                }}>
                                    <div style={{
                                        width: "40px",
                                        height: "40px",
                                        border: "2px solid #ccc",
                                        borderRadius: "4px",
                                        position: "relative"
                                    }}>
                                        <div style={{
                                            position: "absolute",
                                            top: "-2px",
                                            left: "-2px",
                                            width: "44px",
                                            height: "2px",
                                            backgroundColor: "#ccc",
                                            transform: "rotate(45deg)",
                                            transformOrigin: "center"
                                        }}></div>
                                    </div>
                                </div>
                                <div style={{ 
                                    fontSize: "16px", 
                                    color: "#999", 
                                    fontWeight: "500"
                                }}>
                                    Image Not Available
                                </div>
                            </div>
                        )}
                    </div>
                    <div style={{ marginTop: "10px" }}>
                        {images.img1 && (images.img1.startsWith("data:image/") || images.img1.startsWith("data:application/octet-stream")) && !images.img1.includes("data:image/svg+xml") ? (
                        <>
                            <div style={styles.subHeading}>AI Inference:</div>
                            {operatorOverride?.left?.fundus ? (
                                <div style={styles.text2}>Abstained due to operator override</div>
                            ) : (
                                <>
                                    <div style={{...styles.text2, color: DR_GRADE_STYLES[leftInference]?.color || styles.text2.color, fontWeight: "600"}}>{leftInference}</div>
                                    {leftDME && (
                                        <div style={{...styles.text2, marginTop: "5px", color: leftDME === "DME" ? DME_COLORS.present : DME_COLORS.absent, fontWeight: "600"}}>
                                            {leftDME === "DME" ? "Diabetic Macular Edema (DME) present" : "Diabetic Macular Edema (DME) absent"}
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <div style={styles.subHeading}>Image Not Available:</div>
                            <div style={styles.text2}>{singleImageReason || "Single image mode"}</div>
                        </>
                        )}
                    </div>
                </div>
            </div>
            {/* <div style={{ margin: "10px 0" }}>
                <div style={styles.textHeading}>Notes</div>
                <div style={styles.text}>{notes}</div>
            </div> */}
            {/* <div style={{ margin: "20px 0" }}>
                <div style={styles.subHeading}>AI Generated Analysis: </div>
                <div style={styles.text2}>{rightInference} in the right eye, {leftInference} in the left eye. further medical examination is suggested.</div>
            </div> */}
            <div style={{ margin: "20px 0" }}>
                <div style={styles.subHeading}>Next Steps</div>
                <div style={styles.text2}>Suggestion: {nextSteps[1]}</div>
            </div>
            
            <div style={{ marginTop: "5px", border: "2px solid #ccc", borderRadius: "5px", padding: "10px" }}>
                <div style={{ fontSize: "20px", fontWeight: "400", color: "#101010" }}>Disclaimer:</div>
                <div style={styles.text2}>{disclaimer}</div>
            </div>
        </div>
    );
};

export default PdfTemplate;